import * as React from 'react';
import ReactLoadable, { LoadingComponentProps } from 'react-loadable';

function Loading(props: LoadingComponentProps) {
  const { error, pastDelay } = props;
  if (error) {
    return <div>Error!</div>;
  }
  if (pastDelay) {
    return null;
  }
  return null;
}

const Loadable = (
  loader: Promise<
    React.ComponentType<any> | { default: React.ComponentType<any> }
  >
) =>
  ReactLoadable({
    loader: () => loader,
    loading: Loading,
  });

export default Loadable;
